import React, { useState } from 'react';
import { useContractState } from '../../context/ContractContext';

export default function ReferralInline() {
  const { userId } = useContractState();
  const [copied, setCopied] = useState(false);
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  // Keep ?ref outside the hash so URL.searchParams picks it up on landing.
  const link = userId ? `${origin}/?ref=${userId}` : `${origin}/`;

  function copy() {
    try {
      navigator.clipboard.writeText(link).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1400);
      });
    } catch (_e) {
      const ta = document.createElement('textarea');
      ta.value = link;
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); setCopied(true); setTimeout(() => setCopied(false), 1400); } catch (_e2) {}
      document.body.removeChild(ta);
    }
  }

  return (
    <div className="ref-strip">
      <div className="lbl">Your Referral Link</div>
      <div className="link-row">
        <span className="val">{link}</span>
        <button className="btn btn-sm btn-primary" onClick={copy}>{copied ? '✓ Copied' : 'Copy'}</button>
      </div>
    </div>
  );
}
